module.exports = __webpack_public_path__ + "img/2.218595cd.gif";